import React, { useEffect, useState } from "react";
import Header from "./components/header";

import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchAsset, fetchAssetAnalytics, fetchRecommendedAssets, invalidateAssetUpdations, invalidateAssetRecommendations, fetchTableOfContents, deleteTableOfContents, invaliadateTableOfContents } from "../../redux/actions/assets";

import Analytics from "./components/analytics";
import EditAsset from "./components/edit";
import { useSelector } from "react-redux";
import _ from "lodash";
import cx from "classnames";
import styles from "./asset.module.scss";
import Loading from "../../components/loading";
import Panel from "./components/animation/panel";
import AssetViewer from "./components/assetViewer";
import RecommendedAssets from "./components/recommendedAssets";
import EmptyMessage from "src/components/emptyMessage";

import GenerateLink from "./components/generateLink";
import Slider from "src/components/slider";
import CloneAsset from "./components/clone";
import AddToCollection from "./components/addCollection";
import EditAssetThumbnail from "./components/edit/components/editAssetThumbnail";
import Toast from "src/components/toast";
import { toast } from "react-toastify";
import SeekAsset from "../seek/components/seekAsset";
import { useAssetAdoption } from "src/redux/actions/adoption/asset";
import { FileService } from "src/services/file.service";
import EventService from "src/services/event.service";
import ShareSettings from "./components/shareSettings";
import LinkedInPost, { IShareUrl } from "./components/linkedInPost";
import { fetchShareTemplate } from "src/redux/actions/shareTemplates";
import { ContentType } from "src/types/common";
import { TemplateType } from "src/types/shareTemplate";
import { fetchLinkedInIntegration } from "src/redux/actions/integrations/linkedIn";
import { generateLink } from "src/redux/actions/link";
import ComposeView from "src/components/compose";
import ComposeDialog from "src/components/compose/components/dialog";
import TableOfContents from "./components/tableOfContents";
import EditContents from "./components/tableOfContents/edit";
import Button from "src/components/button";

const AssetNotFoundSvgIcon = '/images/Unauthorized_Asset.svg';

export const LiteAssetView: React.FC = () => {
  return (
    <div className={styles.liteAssetContainer}>
      <AssetView />
    </div>
  )
}

const AssetView: React.FC = () => {
  const dispatch = useDispatch();
  const { trackAssetScreenView, trackAssetViewed } = useAssetAdoption();
  const { assetId } = useParams<{ assetId: string }>();

  const [showAnalytics, setShowAnalytics] = useState(false);
  const [showEditAsset, setShowEditAsset] = useState(false);
  const [showGenerateLink, setShowGenerateLink] = useState(false);
  const [showEditVideoCaptions, setShowEditVideoCaptions] = useState(false);
  const [showCloneAsset, setShowCloneAsset] = useState(false);
  const [showAddToCollection, setShowAddToCollection] = useState(false);
  const [showEditThumbnail, setShowEditThumbnail] = useState(false);
  const [showRecommendedAssets , setShowRecommendedAssets] = useState(false);
  const [expandedRecommendedAssets, setExpandedRecommendedAssets] = useState(false);
  const [showCompose, setShowCompose] = useState(false);
  const [showSeek, setShowSeek] = useState(false);
  const [recommendedAssetsDismissed, setRecommendedAssetsDismissed] = useState(false);
  const [showShareSettings, setShowShareSettings] = useState(false);
  const [toggleLinkedInPostSlider, setToggleLinkedInPostSlider] = useState(false);
  const [pageMounted, setPageMounted] = useState(false);

  const [showTableOfContents, setShowTableOfContents] = useState(false);
  const [showEditContents, setShowEditContents] = useState(false);
  const [showDeleteTableOfContents, setShowDeleteTableOfContents] = useState(false);

  const loading = useSelector((state: any) =>
    _.get(state, "asset.loading", true),
  );

  const assetLoading = useSelector((state: any) => {
    return  _.get(state, "asset.item.loading");
  });

  const asset = useSelector((state: any) => _.get(state, "asset.item", null));
  const errors = useSelector((state: any) => _.get(state, "asset.errors", []));
  const isAssetPreparing = useSelector((state: any) => _.get(state, "asset.preparing", false));
  const assetMergeStatus = useSelector((state: any) => _.get(state, "asset.merge", null));
  const processedAsset = useSelector((state: any) => _.get(state, "asset.processedAsset", null));
  const recommendedAssets = useSelector((state: any) => _.get(state, "asset.recommended.items", []));
  const deleteTableOfContentsState = useSelector((state) => _.get(state, `asset.tableOfContents.delete`, {}));
  const tableOfContent = useSelector((state) => _.get(state, `asset.tableOfContents.sections`,[]));

  const [searchParams] = useSearchParams();

  const stream = useSelector((state: any) => state.stream);
  const group = useSelector((state: any) => state.group);
  const collection = useSelector((state: any) => _.get(state, "collections.collection", null));
  const linkedInIntegration = useSelector((state: any) => _.get(state, "integrations.linkedIn.item", null));
  const isLinkedInIntegrationActive = linkedInIntegration?.state?.code === "ok";
  const isLinkedInIntegrationExpired = linkedInIntegration?.state?.code === "auth_error";
  const [linkedInShareUrl, setLinkedInShareUrl] = useState<IShareUrl>({ id: "", url: "" });

  const link = useSelector((state: any) => {
    const creating = _.get(state, 'link.generateLink.creating');
    if (creating) {
      return null;
    }

    return _.get(state, 'link.generateLink.link');
  });
  
  const shareTemplates = useSelector((state: any) => state.shareTemplates);
  const shareTemplate = assetId ? shareTemplates[assetId] : null;

  const url = window.location.pathname;
  const isLiteAssetView = _.includes(url, "liteAssetView");

  useEffect(() => {
    if (link && link?.type === 'anonymous') {
      let url = link.url;
      const id = link.id;
      setLinkedInShareUrl({
        url: url,
        id: id
      })
    }
  }, [link]);

  useEffect(() => {
    if( !_.get(deleteTableOfContentsState, "loading",false) && _.get(deleteTableOfContentsState,"succeeded",false)){
      setShowDeleteTableOfContents(false);
      toast(<Toast.Sucess message={"Table of contents deleted successfully!"} />, {
        autoClose: 3000
      });
      dispatch(fetchTableOfContents({id : assetId!}))
    }
  },[deleteTableOfContentsState]);


  const toggleShowAnalytics = () => {
    toggleRecommendedAssets(showAnalytics)
    setShowAnalytics(!showAnalytics);
  };

  const toggleEditAsset = () => {
    if (assetId) {
      dispatch(invalidateAssetUpdations({ id: assetId }));
    }

    toggleRecommendedAssets(showEditAsset)
    setShowEditAsset(!showEditAsset);
  };
  const toggleGenerateLink = () => {
    toggleRecommendedAssets(showGenerateLink)
    setShowGenerateLink(!showGenerateLink);
  };

  const toggleEditVideoCaptions = () => {
    setShowEditVideoCaptions(!showEditVideoCaptions);
  };

  const toggleCloneAsset = () => {
    toggleRecommendedAssets(showCloneAsset)
    setShowCloneAsset(!showCloneAsset);
  };

  const toggleAddToCollection = () => {
    toggleRecommendedAssets(showAddToCollection)
    setShowAddToCollection(!showAddToCollection);
  };

  const toggleEditThumbnail = () => {
    toggleRecommendedAssets(showEditThumbnail)
    setShowEditThumbnail(!showEditThumbnail);
  };
  const toggleCompose = () => {
    toggleRecommendedAssets(showCompose)
    setShowCompose(!showCompose);
  }
  const toggleSeek = () => {
    toggleRecommendedAssets(showSeek)
    setShowSeek(!showSeek);
  }

  const toggleRecommendedAssets = (flag:boolean) => {
    if(_.size(recommendedAssets) > 0 && !recommendedAssetsDismissed) {
    setShowRecommendedAssets(flag);
    }
  }

  const onExpandRecommendedAssets = () => {
    setExpandedRecommendedAssets(!expandedRecommendedAssets);
  }

  useEffect(() => {
    setPageMounted(true);
    if(assetId){
      dispatch(fetchTableOfContents({id : assetId}))
    }
    if (assetId && !shareTemplate) {
      dispatch(
        fetchShareTemplate({
          entityId: assetId,
          entityType: ContentType.Asset,
          templateType: TemplateType.LinkedIn,
        }),
      );

    }
    
    dispatch(fetchLinkedInIntegration());

    if(isLiteAssetView){
      const message={
        isLoaded:true
      }
      window.parent.postMessage(message, "*");
    }
    
    return () => {
      dispatch(invalidateAssetRecommendations());
    }
  }, []);

  useEffect(() => {
    if (assetId) {
      if(showRecommendedAssets){
        toggleRecommendedAssets(true)
      }
      const request = {
        assetId: assetId,
      };
      const querySource = searchParams.get("source");
      const source = querySource && _.split(_.split(querySource, '/')[0], '?')[0];
      const sourceCta = EventService.getSourceCta(source);
      trackAssetScreenView(sourceCta);
      dispatch(fetchAsset(request));
      dispatch(fetchAssetAnalytics(request));
    }

    return () => {
      dispatch(invaliadateTableOfContents());
    }
  }, [assetId])
  


  useEffect(() => {
    if(!assetLoading && asset!= null && assetId) {

      //fetch recommended assets
      dispatch(fetchRecommendedAssets({ id: assetId }));
            
      const fileType = FileService.getFileType(asset.metadata);
      const querySource = searchParams.get("source");
      const source = querySource && querySource.split('/')[0].split('?')[0];
      const sourceId = querySource && querySource.split('/')[1];
      
      const sourceCta = EventService.getSourceCta(source);
      let sourceNameType = EventService.getSourceNameType(sourceCta);

      let sourceName = "";

      switch (sourceCta){
  
        case "Stream":
          sourceName = _.get(stream, `items.${sourceId}.item.name`);
          break;
  
        case "Group":
          sourceName = _.get(group, `${sourceId}.item.name`);
          break;
        
        case "Collection":
          sourceName = _.get(collection, `${sourceId}.item.name`)
          break;
        
        case "weeklyDigest":
        case "dailyDigest":
        case "alertMailer":
          sourceName = "Mailer"
          break;
  
        case "Search":
          sourceName = "";
          break;

        case "Report":
          sourceName = "";
          break;

        case "Content Map":
          sourceName = "";
          break;
  
        default:
          sourceName = "Content Hub";
      }
      if(assetId === asset.id) {
        trackAssetViewed({assetType: fileType, sourceCta: sourceCta, sourceNameType: sourceNameType, sourceName: sourceName });
      }
    }
  }, [assetLoading]);
  
  useEffect(() => {
    if (isAssetPreparing && assetMergeStatus.merged && _.get(asset, "status") === "OK") {
      if (window.location.pathname.includes(processedAsset)) {
        toast(<Toast.Sucess message={"Your asset is ready!"} />, {
          autoClose: 3000
        });

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    }
  }, [isAssetPreparing, assetMergeStatus, asset])


  useEffect(() => {
    if(_.size(recommendedAssets) > 0) {
      setShowRecommendedAssets(true)
    }
  }, [recommendedAssets]);

  const toggleShareSettings = () => {
    setShowShareSettings(!showShareSettings);
  }

  const handleLinkedInClick = () => {

      dispatch(generateLink({
        entityID: assetId!,
        entityType: 'asset',
        type: 'anonymous'
      }))
      setToggleLinkedInPostSlider(!toggleLinkedInPostSlider);
      
  }

  const handleDeleteTableOfContents = () => {
    dispatch(deleteTableOfContents({id: assetId!}))
  }

  if (loading) {
    return (
      <div className={cx(styles.loading, {
      })}>
        <Loading />
      </div>
    );
  }

  const renderError = () => {
    if(errors ){
      var error = errors.error.errors[0];

      if (error.code === 10002) {
        return (
          <div className={styles.emptyContainer}>
          <EmptyMessage
            width={450}
            heading="Sorry!  Some one passed you the wrong information. You were never supposed to see me :). The asset in me does not exist any longer."
            image={AssetNotFoundSvgIcon}
          />
          </div>
        );
      } else if (error.code === 10007) {
        return (
          <div className={styles.emptyContainer}>
          <EmptyMessage    
            width={450}
            heading="I’m sorry it seems like I’m not authorized to show what you are looking for"
            image={AssetNotFoundSvgIcon}
          />
          </div>
        );
      }
    }
  return null
  }

  if (errors || !asset) {
    return renderError();
  }

  return (
    <section
      className={cx(styles.container, {
        [styles.modalOpened]:
          showAnalytics || showEditAsset || showShareSettings || showTableOfContents,
        [styles.modalExpanded]: showEditVideoCaptions,
      })}
    >
      <Header
        showMenubar={!showEditAsset && !showAnalytics && !showShareSettings}
        toggleShowAnalytics={toggleShowAnalytics}
        toggleEditAsset={toggleEditAsset}
        toggleGenerateLink={toggleGenerateLink}
        toggleCloneAsset={toggleCloneAsset}
        toggleAddToCollection={toggleAddToCollection}
        toggleCompose={toggleCompose}
        toggleSeek={toggleSeek}
        toggleRecommendedAssets={toggleRecommendedAssets}
        toggleShareSettings={toggleShareSettings}
        handleLinkedInClick={handleLinkedInClick}
        isLinkedInIntegrationActive={isLinkedInIntegrationActive}
        isLiteAssetView={isLiteAssetView}
      />
      {pageMounted && <AssetViewer
        showTableOfContents={showTableOfContents}
        setShowTableOfContents={setShowTableOfContents}
        isSidePanelOpen={showAnalytics || showEditAsset || showSeek || showShareSettings}
      />}

      <Panel show={showAnalytics} className={styles.modal}>
        <Analytics toggleShowAnalytics={toggleShowAnalytics} />
      </Panel>

      <Panel show={showSeek} className={styles.modal}>
        <SeekAsset onClose={toggleSeek} assetId={assetId || ""} />
      </Panel>

      <Panel show={showEditAsset} className={styles.modal}>
        <EditAsset
          asset={asset}
          toggleEditAsset={toggleEditAsset}
          toggleEditVideoCaptions={toggleEditVideoCaptions}
          toggleEditThumbnail={toggleEditThumbnail}
          showEditVideoCaptions={showEditVideoCaptions}
          handleEditContentsClick={() => {
            setShowEditAsset(false);
            setShowEditContents(true)}
          }
          handleDeleteTableOfContents={() => {
            _.size(tableOfContent) > 0 && setShowDeleteTableOfContents(true)
            setShowEditAsset(false);
          }}
        />
      </Panel>

      <Panel show={showTableOfContents} className={cx(styles.modal, styles.tableOfContentsPanel)}>
        <TableOfContents asset={asset} onClose={() => setShowTableOfContents(false)}/>
      </Panel>

      <Panel show={showEditContents} className={styles.modal}>
        <EditContents asset={asset} handleClose={() => setShowEditContents(false)}/>
      </Panel>
     
      <Panel show={showShareSettings} className={styles.modal}>
        {showShareSettings && <ShareSettings linkedInShareUrl={linkedInShareUrl} entity={asset} onCancel={() => setShowShareSettings(false)}/>}
      </Panel>

      <Slider.Dialog
        width={"380px"}
        show={showGenerateLink}
        onClose={toggleGenerateLink}
      >
        {showGenerateLink && (
          <GenerateLink entity={asset} onClose={toggleGenerateLink} />
        )}
      </Slider.Dialog>

      <Slider.Dialog
        width={"380px"}
        show={showCloneAsset}
        onClose={toggleCloneAsset}
      >
        {showCloneAsset && assetId && (
          <CloneAsset
            onClose={toggleCloneAsset}
            show={showCloneAsset}
            asset={asset}
          />
        )}
      </Slider.Dialog>

      <Slider.Dialog
        width={"380px"}
        show={showAddToCollection}
        onClose={toggleAddToCollection}
      >
        {showAddToCollection && (
          <AddToCollection
            onClose={toggleAddToCollection}
            show={showAddToCollection}
            assets={[asset]}
            sourceType="Asset Detail"
          />
        )}
      </Slider.Dialog>

      <Slider.Dialog
        width={"380px"}
        show={showEditThumbnail}
        onClose={toggleEditThumbnail}
      >
        {showEditThumbnail && (
          <EditAssetThumbnail
            asset={asset}
            show={showEditThumbnail}
            onClose={toggleEditThumbnail}
          />
        )}
      </Slider.Dialog>

      <Slider.Dialog
        width={"380px"}
        show={showDeleteTableOfContents}
        onClose={() => setShowDeleteTableOfContents(false)}
      >
        <Slider.Header
          title="delete table of contents"
          message={`${_.size(tableOfContent)} contents`}
        />
        <Slider.Body>
          <p className={styles.description} style={{ marginBottom: 10 }}>
            Are you sure you want to delete “table of contents” ? “{_.size(tableOfContent)} contents” will be removed, this step cannot be undone.
          </p>
        </Slider.Body>

        <Slider.Actions>
          <Button
            icon="paperflite-tick"
            text={_.get(deleteTableOfContentsState,"loading",false) ? "Deleting..." : "Confirm"}
            variant="primary"
            disabled={_.get(deleteTableOfContentsState,"loading",false)}
            onClick={handleDeleteTableOfContents}
          />
          <Button
            text="Cancel"
            variant="secondary"
            disabled={false}
            onClick={() => setShowDeleteTableOfContents(false)}
          />
        </Slider.Actions>

      </Slider.Dialog>

      <ComposeDialog
        sourceType = "Share Asset"
        show={showCompose}
        dialog={true}
        initialContent={[asset]}
        onClose={toggleCompose}
      />

     {toggleLinkedInPostSlider && <LinkedInPost entityType={ContentType.Asset} shareUrl={linkedInShareUrl} isLinkedInIntegrationExpired={isLinkedInIntegrationExpired} isLinkedInIntegrationActive={isLinkedInIntegrationActive} entity={asset} show={toggleLinkedInPostSlider} onCancel={() => setToggleLinkedInPostSlider(false)}/>}

      <Panel
        show={showRecommendedAssets}
        className={cx(styles.recommendedAssetsPanel, {
          [styles.expanded]: expandedRecommendedAssets,
        })}
        config={{
          enter: { opacity: 1, right: "1.5%" },
        }}
      >
        <RecommendedAssets
          onExpand={onExpandRecommendedAssets}
          onClose={() => {
            toggleRecommendedAssets(false);
            setRecommendedAssetsDismissed(true); //if the user dismisses the popup we dont show it again hence adding this flag
          }}
        />
      </Panel>
    </section>
  );
};

export default AssetView;
